import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import { _ } from 'core-js';
import React from 'react';
import connect from 'react-redux/es/connect/connect';
import { bindActionCreators } from 'redux';
import EmpresaTagApp from './EmpresaTagApp';
import * as Actions from './Store/Actions/EmpresaTagActions';

const EmpresaTagNewButton = ({ openNewDialog, callback, xappRouteParams, closeNewDialog, tipo, iconProps = null, children = null }) => {
    return (
        <React.Fragment>
            <div className='hidden'>
                <EmpresaTagApp
                    tipo={tipo}
                    xappRouteParams={xappRouteParams}
                    isButton={true}
                    callback={() => {
                        callback();
                        closeNewDialog();
                    }}
                />
            </div>
            {_.isNull(children) ?
                <XAPPButton
                    tooltip={{ "title": "Novo", "placement": "top" }}
                    type="icon"
                    className="p-8"
                    variant="contained"
                    color="textSecondary"
                    onClick={() => openNewDialog()}
                    iconProps={iconProps !== null ? iconProps : "text-18 text-white"}
                    icon={"add"}
                />
                :
                <div className="cursor-pointer" onClick={() => openNewDialog()}>
                    {children}
                </div>
            }
        </React.Fragment>
    );
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openNewDialog: Actions.openNewDialog,
        closeNewDialog: Actions.closeNewDialog,
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(EmpresaTagNewButton);
